import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import BodyWrap from "../../utils/BodyWrap";
import GeneralLoader from "../../GeneralLoader";
import ContentDiv from "../../utils/ContentDiv";
import LoginForm from "./LoginForm";
import LoginLinks from "./LoginLinks";

// State
import { getTranslations } from "../../../store/actions/translations";

class ReviewerLogin extends Component {
	static initialAction(store, props, translationKey = null) {
		const promises = [];
		const translationSections = ["reviewer_login_form"];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		const resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		return promises;
	}

	componentWillMount() {
		// Grab translations if not already in store
		if (!this.props.translations.pages[this.props.translationKey]) {
			ReviewerLogin.initialAction(null, this.props);
		}
	}

	render() {
		const { translationsLoading, translations } = this.props;

		return (
			<BodyWrap>
				<main className="content-bottom-margin">
					<div className="content-header centered">
						{translationsLoading ? (
							<GeneralLoader />
						) : !!translations.pages[this.props.translationKey] ? (
							<ContentDiv className="page-text">
								{translations.pages[this.props.translationKey].content}
							</ContentDiv>
						) : null}
					</div>
					{!translationsLoading && (
						<React.Fragment>
							<LoginForm />
							<LoginLinks />
						</React.Fragment>
					)}
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		siteInfo: state.siteInfo,
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations }
)(ReviewerLogin);



// WEBPACK FOOTER //
// ./src/components/reviewer/login/ReviewerLogin.js